import { createSlice } from '@reduxjs/toolkit'
import { RootState, AppThunk } from './store'
import { post } from '../utils/rest'
import * as Toast from 'components/Toast'
import { ActivitySearchHit, SearchObject, SearchResult } from 'types/types'

export interface SearchState {
  isLoading: boolean
  searchHits: ActivitySearchHit[]
  noOfHits: number | null
}

const createInitialState = (): SearchState => {
  return {
    isLoading: false,
    searchHits: [],
    noOfHits: null,
  }
}

export const searchSlice = createSlice({
  name: 'search',
  initialState: createInitialState(),
  reducers: {
    fetchSearchBegin: (state) => {
      state.isLoading = true
    },
    fetchSearchSuccess: (state, action) => {
      state.isLoading = false
      state.searchHits = action.payload.searchHits as ActivitySearchHit[]
      state.noOfHits = action.payload.totalCount
    },
    fetchSearchFail: (state) => {
      state.isLoading = false
    },
  },
})

export const { fetchSearchBegin, fetchSearchSuccess, fetchSearchFail } = searchSlice.actions

export const searchAsync =
  (
    searchString: string,
    skip: number,
    size: number,
    artForm?: string,
    targetGroup?: string,
    tags?: string[],
    searchCreativeSchool?: boolean,
    specialSchool?: boolean,
  ): AppThunk =>
  async (dispatch) => {
    dispatch(fetchSearchBegin())
    try {
      const searchQuery = `/api/search`
      const searchObject: SearchObject = {
        searchText: searchString === 'null' ? '*' : searchString,
      }

      if (size) searchObject.size = size
      if (skip) searchObject.skip = skip
      if (artForm) searchObject.artForm = artForm
      if (targetGroup) searchObject.targetGroup = targetGroup
      if (tags && tags.length > 0) searchObject.tags = tags
      if (searchCreativeSchool) searchObject.filterCreativeSchool = searchCreativeSchool
      if (specialSchool) searchObject.filterSpecialSchool = specialSchool

      const res = await post<SearchResult>(searchQuery, searchObject)
      if (res.status === 200) {
        const searchHits = res.parsedBody?.data.hits.map((hit) => {
          return hit.document
        })
        const totalCount = res?.parsedBody?.data.totalCount
        dispatch(fetchSearchSuccess({ searchHits, totalCount }))
      } else {
        Toast.dispatchToastError({
          message: res.parsedBody?.message ?? 'Det gick inte att hämta sökträffar',
          correlationId: res.parsedBody?.correlationId,
        })
        dispatch(fetchSearchFail())
      }
    } catch {
      Toast.dispatchToastError({ message: 'Fel inträffade vid sökning' })
      dispatch(fetchSearchFail())
    }
  }

export const selectSearchState = (state: RootState): SearchState => state.search
export default searchSlice.reducer
